<template>
  <div class="comment" v-loading="loading">
    <div class="search-header">
      <div v-show="!searchExpand" class="content">
        <el-input
          size="small"
          placeholder="输入定向包名称查询"
          class="input-with-select"
          clearable
          v-noEmoji
          @keyup.enter.native="handleSearch"
          v-model="searchForm.directPackageName"
        >
          <el-button slot="append" @click="handleSearch" icon="el-icon-search"></el-button>
        </el-input>
      </div>
      <div v-show="searchExpand">
        <el-form ref="searchForm" label-width="90px" label-position="left">
          <div class="search-items">
            <el-form-item label="定向包名称">
              <el-input v-model="searchForm.directPackageName" size="small" @keyup.enter.native="handleSearch"></el-input>
            </el-form-item>
            <el-form-item label="投放渠道">
              <el-select v-model="searchForm.channelId" filterable clearable>
                <el-option v-for="(item, index) in channelOptions" :key="index" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="广告位">
              <el-select v-model="searchForm.spaceId" filterable clearable>
                <el-option v-for="(item, index) in spaceOptions" :key="index" :value="item.value" :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-button type="primary" size="small" icon="el-icon-search" @click="handleSearch">查询</el-button>
            <el-button type="primary" size="small" plain icon="el-icon-refresh-right" @click="resetSearch">重置</el-button>
          </div>
        </el-form>
      </div>
      <el-button type="text" @click="switchExpand">{{ searchExpand ? '收起筛选' : '展开筛选' }}</el-button>
    </div>
    <ContentBox class="content-list">
      <Table ref="table" :props="table.props" :header="table.header" :data="table.data" />
      <pagination
        :currentpage="pager.currentPage"
        :pagesize="pager.pageSize"
        :totalcount="pager.totalCount"
        @handle-size-change="handleSizeChange"
        @handle-current-change="handleCurrentChange"
      ></pagination>
    </ContentBox>
    <!--详情-->
    <el-drawer
      size="50%"
      class="detail-drawer"
      :visible.sync="drawer"
      :modal="false"
      :destroy-on-close="true"
      :with-header="false"
    >
      <DirectPackageDetail :model="{ ...model }" @closeDrawer="drawer = false" />
    </el-drawer>
  </div>
</template>

<script>
import ContentBox from '@/components/common/ContentBox'
import DirectPackageDetail from './DirectPackageDetail.vue'
import useSpaceComponent from '@/hooks/useSpaceComponent'

export default {
  name: 'DirectPackage',
  components: {
    ContentBox,
    DirectPackageDetail
  },
  data() {
    return {
      loading: false,
      drawer: false,
      searchForm: {
        directPackageName: '',
        channelId: '',
        spaceId: ''
      },
      table: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '定向包编号',
            align: 'left',
            prop: 'directPackageId',
            'min-width': 50,
            'show-overflow-tooltip': true
          },
          {
            label: '定向包名称',
            align: 'left',
            prop: 'directPackageName',
            'min-width': 100,
            'show-overflow-tooltip': true
          },
          {
            label: '投放渠道',
            align: 'left',
            prop: 'channelName',
            'min-width': 100,
            'show-overflow-tooltip': true
          },
          {
            label: '广告位',
            align: 'left',
            prop: 'spaceName',
            'min-width': 100,
            'show-overflow-tooltip': true
          },
          {
            label: '操作',
            align: 'left',
            'min-width': 60,
            fixed: 'right',
            render: (h, { row }) => {
              return <div>
                <el-button type="text" onClick={() => { this.showDetail(row) }}>详情</el-button>
                <el-button type="text" onClick={() => { this.handleDelete(row) }}>删除</el-button>
              </div>
            }
          }
        ],
        data: []
      },
      pager: {
        currentPage: 1,
        pageSize: 10,
        totalCount: 0
      },
      model: {},
      searchExpand: false,
      spaceOptions: [],
      channelOptions: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getBaseInfo()
      this.handleSearch()
    },
    getBaseInfo() {
      this.$service.getBaseDict().then(data => {
        this.spaceOptions = data.spaceList.map((item) => {
          return {
            label: item.spaceName,
            value: item.spaceId
          }
        })
        this.channelOptions = data.channelIdList.map((item) => {
          return {
            label: item.channelName,
            value: item.channelId
          }
        })
      })
    },
    handleSearch() {
      this.pager.currentPage = 1
      this.fetchData()
    },
    resetSearch() {
      this.searchForm.directPackageName = ''
      this.searchForm.channelId = ''
      this.searchForm.spaceId = ''
      this.handleSearch()
    },
    fetchData() {
      this.loading = true
      const [pageSize, pageNo] = [this.pager.pageSize, this.pager.currentPage]
      const filter = {
        pageSize,
        pageNo,
        directPackageName: this.searchForm.directPackageName || undefined,
        channelId: (this.searchExpand && this.searchForm.channelId) ? this.searchForm.channelId : undefined,
        spaceId: (this.searchExpand && this.searchForm.spaceId) ? this.searchForm.spaceId : undefined
      }
      this.$service
        .getDirectPackagePageList(filter)
        .then((data) => {
          this.loading = false
          this.table.data = data.rows || []
          this.pager.totalCount = data.total || 0
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleSizeChange(val) {
      this.pager.pageSize = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.pager.currentPage = val
      this.fetchData()
    },
    showDetail(row) {
      const { getComponentsDetail } = useSpaceComponent()
      this.loading = true
      this.$service
        .getDirectPackageDetail({ directPackageId: row.directPackageId })
        .then(data => {
          const res = data.packageDetailModelShow
          this.model.directPackageName = data.directPackageName
          this.model.spaceName = data.spaceName
          this.model.channelName = data.channelName
          // 尺寸定向
          this.model.adScheduleDeviceSizes = (res.adScheduleDeviceSizes || [])
            .map((item) => {
              return item.beginSize + '-' + item.endSize
            })
            .join('')
          // 品牌(1000-2000) 机型(5000-6000、80000-90000)
          this.model.adTagDeviceList = (res.adTagDeviceList || [])
            .filter((item) => item.tagDeviceId < 6000 || item.tagDeviceId >= 7000)
            .map((item) => item.tag)
          // 视频源定向(6000-7000)
          this.model.videoDeviceList = (res.adTagDeviceList || [])
            .filter((item) => item.tagDeviceId >= 6000 && item.tagDeviceId < 7000)
            .map((item) => item.tag)
          // mac标签
          this.model.customTagList = (res.customTagList || []).map((item) => item.adCustomTagName)
          // 机型标签
          this.model.tagCustomTagList = (res.tagCustomTagList || []).map(item => item.adCustomTagName)
          // lbs标签
          this.model.lbsTagsList = (res.lbsTagsList || []).map((item) => item.circleName)
          // dmp
          this.model.adScheduleDmps = (res.adScheduleDmps || []).map((item) => {
            return {
              text: item.text,
              matchType: item.matchType
            }
          })
          this.model.dmpMatchType = this.model.adScheduleDmps.length > 0 ? this.model.adScheduleDmps[0].matchType : undefined
          // 广告DMP
          this.model.crowdList = (res.adScheduleCrowds || []).map((item) => {
            return {
              text: item.crowdName,
              matchType: item.matchType
            }
          })
          this.model.crowdMatchType = this.model.crowdList.length > 0 ? this.model.crowdList[0].matchType : undefined
          // 业务定向
          this.model.adScheduleBusinessSettings = getComponentsDetail(res.componentList, res.adScheduleBusinessSettings)
          // 三方dmp定向
          this.model.thirdDmpEntityList = getComponentsDetail(res.dmpComponentList, res.thirdDmpEntityList)
          // 场景标签
          this.model.adScheduleVideoTags = res.adScheduleVideoTags

          this.loading = false
          this.drawer = true
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleCloseDrawer() {
      this.drawer = false
    },
    handleDelete(row) {
      this.$confirm('确定删除此定向包吗？', '提示', {
        showClose: false,
        center: true
      }).then(() => {
        this.$service.delDirectPackage([row.directPackageId]).then((res) => {
          this.$message.success('删除成功!')
          this.fetchData()
        })
      })
    },
    switchExpand() {
      this.searchExpand = !this.searchExpand
      if (!this.searchExpand) {
        this.searchForm.channelId = ''
        this.searchForm.spaceId = ''
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.comment
  position relative
  height 100%
  .search-header
    display flex
    flex-direction row
    justify-content flex-start
    padding 15px 22px
    margin-bottom 16px
    background #fff
    width 100%
    border-bottom 1px solid #dcdfe6
    box-shadow 0 1px 4px 0 rgba(0, 0, 0, 0.06)
    align-items center
    box-sizing border-box
    .content
      margin-right 10px
      .el-form-item
        margin-bottom 0px
.search-items
  display flex
  .el-form-item
    margin-right 10px
    margin-bottom 0
  .el-button
    margin 0 10px
    height 36px
.content-list
  margin 16px
  background #fff
  border none
>>>.el-table-button-text
  color #1890FF
>>>.el-table-button-text.is-disabled
  color #C0C4CC
</style>
